import React, { Component } from 'react';
import './Patients.css'
import { connect } from "react-redux";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../axios-cmk";
import { hidePatientDetails, loadPatientDetails, updatePatient } from "../../store/actions";
import { Badge, Button, Card, CardBody, CardHeader, CardTitle, Modal, ModalFooter, Table } from "reactstrap";


const mapDispatchToProps = dispatch => {
    return {
        loadPatientDetails: (patient_id) => dispatch(loadPatientDetails(patient_id)),
        hidePatientDetails: () => dispatch(hidePatientDetails()),
        updatePatient: (patient_id, patientData) => dispatch(updatePatient(patient_id, patientData))
    }
};

export const mapPropsToProps = state => {
    return {
        patients: state.patients.patients,
        patient_id: state.patients.selected_patient_id,
        patient: state.patients.selected_patient,
        patient_details_shown: state.patients.patient_details_shown,
    };
};

class PatientDetailsPanelStateless extends Component {

    state = {
        hidden_reason: true
    };

    toggle_reason = () => {
        this.setState({
            hidden_reason: !this.state.hidden_reason
        })
    };

    toggle_regular = () => {
        this.props.updatePatient(this.props.patient.id, { 'regular': !this.props.patient.regular })
    };

    render() {
        const regular_style = this.props.patient.regular ? "success" : "light";
        const reason = this.state.hidden_reason ? (
            <div className="hiddenReason">Powód terapii jest ukryty, kliknij aby wyświetlić</div>
        ) : this.props.patient.curation_reason;
        return (
            <Card>
                <CardHeader>Karta pacjenta
                    <Badge color={regular_style} onClick={this.toggle_regular} className="regularPatientBadge" pill>
                        Stały pacjent</Badge>
                </CardHeader>
                <CardBody>
                    <CardTitle>{this.props.patient.label}</CardTitle>
                    <Table className="patientDetail">
                        <tbody>
                        <tr>
                            <th scope="row">Opiekun</th>
                            <td>{this.props.patient.guardian_name} {this.props.patient.guardian_last_name}</td>
                        </tr>
                        <tr>
                            <th scope="row">Telefon</th>
                            <td>
                                <div>{this.props.patient.phone}</div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Powód</th>
                            <td onClick={this.toggle_reason}>{reason}</td>
                        </tr>
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        )
    }
}

const PatientDetailsPanel = connect(mapPropsToProps, mapDispatchToProps)(withErrorHandler(PatientDetailsPanelStateless, axios));

class PatientDetailsModal extends Component {

    componentDidMount() {

    }

    onOpened = () => {
        this.props.loadPatientDetails(this.props.patient_id);
    };

    render() {
        return (
            <Modal isOpen={this.props.patient_details_shown}
                   toggle={this.toggle}
                   onOpened={this.onOpened}
                   className="patientDetailsWindow">
                <PatientDetailsPanel />
                <ModalFooter>
                    <Button color="link" onClick={this.props.hidePatientDetails}>Zamknij</Button>
                </ModalFooter>
            </Modal>
        )
    }
}


export default connect(mapPropsToProps, mapDispatchToProps)(withErrorHandler(PatientDetailsModal, axios));


// WEBPACK FOOTER //
// ./src/components/Patients/Patients.js